import React from "react";
import { Box, Button, ButtonGroup, IconButton, TableRow } from "@material-ui/core";
import Basket from "../../../shared/Basket";
import { ticketBasketHeaders } from "../../../messages/basketTable";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { format } from "date-fns";
import { TicketBillLine } from "../../../models/TicketBillLine";
import TableCell from "@material-ui/core/TableCell";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import useWithDispatch from "../../../utils/hook/withDispatchHook";
import {
  addTicketWithExerciseToBasket,
  removeTicketWithExerciseFromBasket,
  removeTicketWithSeatFromBasket
} from "../../../store/basket/basketActions";
import DeleteIcon from "@material-ui/icons/Delete";
import getId from "../../../utils/getId";
import { setErrors } from "../../../store/alerts/alertsActions";
import { Seat } from "../../../models/Seat";
import { Identifiable } from "../../../models/Identifiable";
import { UNBLOCK_SEAT } from "../../../api/apiRoutes";
import { get } from "../../../api";

const isBasket = (basket: TicketBillLine[], tempId: string) => {
  return basket.some(item => item.tempId === tempId);
};

const validateBasket = (basket: TicketBillLine[], tempId: string, exerciseMaxQnt: number) => {
  const item = basket.filter(item => item.tempId === tempId)[0];
  return item.quantity === exerciseMaxQnt;
};

const BasketTicket: React.FC = () => {
  const tickets = useSelector((state: State) => state.basket.basket);
  const basket = useSelector((state: State) => state.basket.basket);
  const withDispatch = useWithDispatch();
  // const { addTicket } = useTicketPage();
  const addTicket = (ticket: TicketBillLine) => {
    if (isBasket(basket, ticket.tempId)) {
      if (
        validateBasket(
          basket,
          ticket.tempId,
          ticket.ticketAccessList[0].exercise.capacity - ticket.ticketAccessList[0].exercise.reserved
        )
      ) {
        withDispatch(setErrors)(["Brak miejsc na wybrany termin"]);
      } else {
        withDispatch(addTicketWithExerciseToBasket)(ticket);
      }
    } else {
      withDispatch(addTicketWithExerciseToBasket)(ticket);
    }
  };
  const isSeatSale = (itemBasket: TicketBillLine) => {
    return tickets.some(item =>
      item.ticketAccessList.length > 0
        ? getId(item.ticketAccessList[0].seat) === getId(itemBasket.ticketAccessList[0].seat)
        : false
    );
  };

  const removeSeatFromBasket = (item: TicketBillLine) => {
    if (item.ticketAccessList.length > 0) {
      unblockSeat(item.ticketAccessList[0].exercise, item.ticketAccessList[0].seat ?? ({} as Seat));
    }
    withDispatch(removeTicketWithSeatFromBasket)(item);
  };

  const unblockSeat = async (exercise: Identifiable, seatIds: Identifiable) => {
    await get(UNBLOCK_SEAT(exercise, seatIds));
  };

  return (
    <React.Fragment>
      {tickets.length > 0 ? (
        <Basket headers={ticketBasketHeaders}>
          {tickets.map((item: TicketBillLine, index: number) => (
            <TableRow key={index}>
              <TableCell align={"center"}>
                <Box>{item.assort.name}</Box>
              </TableCell>

              <TableCell align={"center"}>
                {item.ticketAccessList.length > 0
                  ? item.ticketAccessList.map((item, index) => (
                      <React.Fragment key={index}>
                        <Box style={{ width: "100%" }}>
                          {item.exercise.name}/{format(new Date(item.exercise.startTime), "dd.MM.yyyy HH:mm")}
                        </Box>
                        {item.seat && item.rowZone && (
                          <Box style={{ width: "100%" }}>
                            Rząd: {item.rowZone.name}, Miejsce: {item.seat.name}
                          </Box>
                        )}
                      </React.Fragment>
                    ))
                  : "Brak atrakcji"}
              </TableCell>
              <TableCell align={"center"}>
                <Box>{item.assort.listPrice} zł</Box>
              </TableCell>
              <TableCell align={"center"}>
                <Box>{item.quantity}</Box>
              </TableCell>
              <TableCell align={"center"}>
                <Box>{item.assort.listPrice * item.quantity} zł</Box>
              </TableCell>
              <TableCell align={"center"}>
                {isSeatSale(item) ? (
                  <Button onClick={() => removeSeatFromBasket(item)} variant={"outlined"} color={"primary"}>
                    <DeleteIcon />
                  </Button>
                ) : (
                  <React.Fragment>
                    <ButtonGroup>
                      <IconButton onClick={() => withDispatch(removeTicketWithExerciseFromBasket)(item)}>
                        <RemoveIcon />
                      </IconButton>
                      <Button style={{ border: "1px solid #000" }}>{item.quantity}</Button>
                      <IconButton onClick={() => addTicket(item)}>
                        <AddIcon />
                      </IconButton>
                    </ButtonGroup>
                  </React.Fragment>
                )}
              </TableCell>
            </TableRow>
          ))}
        </Basket>
      ) : (
        <div style={{ textAlign: "center" }}>
          <h2>Koszyk jest pusty</h2>
        </div>
      )}
    </React.Fragment>
  );
};

export default BasketTicket;
